export const routesTypes = {
    changeCollection: "[Routes] Change collection",
    mergeObject: "[Routes] Merge collection",
    reset: "[Routes] RESET Routes",
};
